import React from "react";
import AppDialog from "../../../components/Common/AppDialog";
import "../../../components/Common/common.css";
import CustomTextField from "../../../components/Form/CustomTextField";
//Import Breadcrumb

const RejectModal = ({
    open, values, setFormValues = false,
    setOpen, setPositivePress }) => {
    return (
        <React.Fragment>
            <AppDialog
                open={open}
                close={() => setOpen(false)}
                titleIcon={'error'}
                title={'Reject product listing'}
                positiveTitle={'Reject product'}
                positiveButtonStyle={{ backgroundColor: '#ED1A3D', color: 'white', border: '1px solid #ED1A3D' }}
                positivePress={() => setPositivePress("Reject")}
                negativeTitle={'Cancel'}
                negativePress={() => setOpen(false)}
                width={'30%'}
            >
                <div className="mb-3">Please provide a reason for rejecting the product listing: </div>
                <CustomTextField
                    title={'Reason for Rejection: '}
                    values={values?.reject_reason}
                    placeholder={''}
                    multiline={true}
                    rows={4}
                    onChange={(e) => setFormValues((prevValues) => ({
                        ...prevValues,
                        reject_reason: e
                    }))}
                />
            </AppDialog>
        </React.Fragment>
    );
};

export default RejectModal;
